<template>
  <b-container v-loading="loading">
    <b-modal
      title="Loglar"
      class="large-modal"
      size="large"
      hide-footer
      v-model="modal"
    >
        <table style="table-layout:fixed; font-size:13px;vertical-align: middle;" class="table table-striped table-bordered">
          <thead>
            <tr>
              <th style="width:40px">ID</th>
              <th>İsim</th>
              <th>IP</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(item,key) in logs" :key="key">
              <td>{{ item.id }}</td>
              <td>{{ item.request }}</td>
              <td>{{ item.ip }}</td>
            </tr>
          </tbody> 
        </table>
    </b-modal>
      <b-col cols="12" style="margin-top:15px;">
        <b-card header="Filtreleme" header-tag="header" class="filter-panel">
          <b-row>
              <b-col cols="1">
                  <b-form-group label="ID">
                    <b-form-input type="number" size="sm" v-model="filter.id" placeholder="ID"></b-form-input>
                  </b-form-group>
              </b-col>
              <b-col cols="2">
                  <b-form-group label="Kullanıcı ismi">
                    <b-form-input size="sm" v-model="filter.name" placeholder="İsim"></b-form-input>
                  </b-form-group>
              </b-col>
              <b-col cols="2">
                  <b-form-group label="Kullanıcı mail">
                    <b-form-input size="sm" v-model="filter.mail" placeholder="Mail"></b-form-input>
                  </b-form-group>
              </b-col>
              <b-col cols="2" v-if="user.is_master">
                  <b-form-group label="Firma">
                    <b-form-select size="sm" v-model="filter.client_id" class="form-control mb-3 form-control-sm"  placeholder="Ödeme Notunuz">
                      <b-form-select-option disabled :value="null">Seçiniz</b-form-select-option>
                      <b-form-select-option :value="item.id" v-for="(item,key) in clients" :key="key">{{ item.title }}</b-form-select-option>
                    </b-form-select>
                  </b-form-group>
              </b-col>
              <b-col cols="2">
                  <b-form-group label="Tutar">
                    <b-form-input type="number" size="sm" v-model="filter.amount" placeholder="Tutar"></b-form-input>
                  </b-form-group>
              </b-col>
              <b-col cols="1">
                <b-form-group label="Durum">
                  <b-form-select size="sm" v-model="filter.status" class="form-control mb-3 form-control-sm">
                    <b-form-select-option disabled :value="null">Seçiniz</b-form-select-option>
                    <b-form-select-option :value="0">Bekliyor</b-form-select-option>
                    <b-form-select-option :value="1">Onaylandı</b-form-select-option>
                    <b-form-select-option :value="2">Reddedildi</b-form-select-option>
                  </b-form-select>
                </b-form-group>
              </b-col>
              <b-col cols="2">
                <b-form-group style="margin-top:30px">
                  <b-button variant="primary" @click="filterBtn()" style="font-size:12px; margin-right:10px" size="sm">Filtrele</b-button>
                  <b-button variant="danger" @click="clearBtn()" style="font-size:12px" size="sm">Temizle</b-button>
                </b-form-group>
              </b-col>
          </b-row>
        </b-card>
      </b-col>
    <b-row>
      <div style="margin: 15px 0">
      </div>
      <div>
        <div class="table-responsive">
          <table style="table-layout:fixed; font-size:13px;vertical-align: middle;" class="table table-striped table-bordered" v-if="!_.isEmpty(data)">
            <thead>
              <tr>
                <th style="width:40px">ID</th>
                <th>İsim</th>
                <th style="width:200px">Email</th>
                <th>Firma</th>
                <th>Tutar</th>
                <th>Oluşturma Tarihi</th>
                <th>Sonuçlanma Tarihi</th>
                <th>IP</th>
                <th>Durumu</th>
                <th v-if="user.is_master">Detaylar</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(item,key) in data" :key="key">
                <td>{{ item.id }}</td>
                <td>{{ item.name }}</td>
                <td>{{ item.email }}</td>
                <td>{{ item.company_name }}</td>
                <td>{{ item.amount }}</td>
                <td>{{ $moment(item.created_at).format('MM.DD.YYYY h:mm:ss') }}</td>
                <td>{{ $moment(item.closed_at).format('MM.DD.YYYY h:mm:ss') }}</td>
                <td>{{ item.ip }}</td>
                <td>{{ item.status_name }}</td>
                <td v-if="user.is_master">
                  <b-button variant="warning" @click="getLogs(item.id)" slot="reference"  size="sm">Loglar</b-button>
                </td>
              </tr>
            </tbody>
            <div class="block pagination">
              <el-pagination
                  v-if="filter.pageTotal > 0"
                  @size-change="handleSizeChange"
                  @current-change="fetch"
                  :current-page.sync="filter.page"
                  :page-sizes="sizes"
                  :page-size="filter.size"
                  layout="sizes, prev, pager, next"
                  :total="filter.pageTotal"
              ></el-pagination>
            </div> 
          </table>
        </div>
      </div>
    </b-row>
  </b-container>
</template>

<script>
  export default{
    name: 'TransactionsList',
    data(){
      return{
        modal: false,
        sizes: [10, 20, 50, 100],
        loading:false,
        filter:{
          name:null,
          client_id:null,
          id:null,
          mail:null,
          amount:null,
          status:null,
          pageTotal: 0,
          size: 10,
          page: 1,
          types: []
        },
        logs:[],
        data:[]
      }
    },
    watch:{
        "filter.types": function(val) {
          this.fetch(1, this.filter.size);
        },
    },
    computed:{
      user(){
        return this.$user();
      },
    },
    created(){
      this.fetch();
      this.fetchClients();
    },
    methods:{
      filterBtn(){
        this.fetch(1, this.filter.size);
      },
      clearBtn(){
        this.filter.name = null;
        this.filter.client_id = null;
        this.filter.mail = null;
        this.filter.id = null;
        this.filter.status = null;
        this.filter.mail = null;
        this.filter.amount = null;
        this.fetch(1, this.filter.size);
      },
      handleSizeChange(value){
        this.filter.size = value;
        this.fetch();
      },
      fetchClients(){
        axios.get('/list/clients')
        .then((response) => {
            this.clients = response.data.data;
        })
        .catch((err) => {
        })
        .finally(()=>{
        });
      },
      fetch(page = 1, size = null, silent = false){
        this.filter.page = page;

        if (!_.isNull(size)) 
        {
            this.filter.size = size;
        }
        if(!silent) this.loading = true;
        axios.get('/transactions',{params: this.filter })
        .then((response) => {
          this.data = response.data.data.data;
          this.filter.pageTotal  	= response.data.data.total;
        })
        .catch((err) => {
        })
        .finally(()=>{
          this.loading = false;
        });
      },

      getLogs(id){
        axios.get('transactions/' + id + '/logs')
        .then((response) => {
          this.logs = response.data.data;
          this.modal = true;
        }).catch((err) => {

        }).finally(() => {

        });
      }
    }
  }
</script>

<style>
  .modal-dialog{
    max-width: initial !important;
    width: 1000px !important;
  }
</style>